// import { loadSelfieSegmentationLibs } from "./selfiesegmentationlib.js";
// import { initSegmentation, stopSegmentation } from "./video/videoSegmentation.js";

export async function startVideoPreview(localStream, liveArea, onReady, options = {}) {
    const { isDeviceChange = false, preservedState = {} } = options;

    if (isDeviceChange) {
        const existingVideo = document.getElementById('previewVideo');
        if (existingVideo) {
            existingVideo.srcObject = localStream;

            await new Promise((resolve) => {
                if (existingVideo.readyState >= 2) {
                    resolve();
                } else {
                    existingVideo.onloadedmetadata = () => resolve();
                }
            });

            // if (preservedState.isSegmentationActive && preservedState.backgroundImage) {
            //     const canvas = document.getElementById('segmentedCanvas');
            //     if (canvas) {

            //         // Detener la instancia anterior
            //         if (window._currentSegmentationInstance) {
            //             await stopSegmentation(window._currentSegmentationInstance);
            //             window._currentSegmentationInstance = null;
            //         }

            //         // Esperar un frame para asegurar que el video está renderizando
            //         await new Promise(resolve => requestAnimationFrame(resolve));

            //         // Crear nueva instancia con el mismo fondo
            //         window._currentSegmentationInstance = await initSegmentation(
            //             existingVideo, 
            //             canvas, 
            //             preservedState.backgroundImage
            //         );

            //         // Asegurar que los botones estén en el estado correcto
            //         const changeBgButton = document.getElementById('changeBgButton');
            //         const removeBgButton = document.getElementById('removeBgButton');
            //         if (changeBgButton && removeBgButton) {
            //             changeBgButton.style.display = 'none';
            //             removeBgButton.style.display = 'inline-flex';
            //         }
            //     }
            // }

            updateVoiceIndicator(localStream);

            return;
        }
    }

    liveArea.innerHTML = `
        <div id="videoContainer16_9" 
            style="
                position: relative;
                width: 100%;
                aspect-ratio: 16 / 9;
                max-height: 360px;
                overflow: hidden;
                border-radius: 5px;
            ">
            
            <video id="previewVideo" autoplay playsinline muted
                style="width:100%;height:100%;object-fit:cover;background:#000;border-radius:5px;"></video>

            <!-- <canvas id="segmentedCanvas" style="position:absolute;top:0;left:0;width:100%;height:100%;border-radius:5px;display:none;"></canvas> -->

            <canvas id="overlayCanvas" style="position:absolute; top:0; left:0; width:100%; height:100%; border-radius:5px; pointer-events:none;"></canvas>

            <div id="recordingIndicator" style="position:absolute;top:10px;left:10px;display:none;align-items:center;gap:6px;background:rgba(20,20,20,0.5);backdrop-filter:blur(4px);border-radius:10px;padding:6px 10px;z-index:11;color:white;font-weight:500;font-size:13px;pointer-events:none;box-shadow:0 0 8px rgba(0,0,0,0.2);"> <div class="record-dot" style="width:10px;height:10px;border-radius:50%;background:red;animation: blinkDot 1s infinite;"></div> Grabando </div>

            <div id="voiceIndicatorOverlay"
                style="position:absolute;top:10px;right:10px;display:flex;align-items:center;gap:6px;
                background:rgba(20,20,20,0.5);backdrop-filter:blur(4px);border-radius:10px;padding:6px 10px;
                z-index:11;pointer-events:none;box-shadow:0 0 8px rgba(0,0,0,0.2);">
                <i class="fas fa-microphone microphone-ckeditor-hover" style="font-size:14px;"></i>
                <div id="voiceBars" style="display:flex;align-items:flex-end;gap:2px;height:16px;">
                    <div class="bar-audio-ckeditor" style="width:2px;height:4px;border-radius:2px;transition:height 0.1s ease;"></div>
                    <div class="bar-audio-ckeditor" style="width:2px;height:6px;border-radius:2px;transition:height 0.1s ease;"></div>
                    <div class="bar-audio-ckeditor" style="width:2px;height:8px;border-radius:2px;transition:height 0.1s ease;"></div>
                    <div class="bar-audio-ckeditor" style="width:2px;height:5px;border-radius:2px;transition:height 0.1s ease;"></div>
                </div>
            </div>

            <!--
            <div style="position:absolute; bottom:10px; right:10px; display:flex; align-items:center; gap:10px; z-index:6;">
                <button id="changeBgButton" type="button" class="btn btn-primary imagepicker-button-action m-l-0" title="Cambiar fondo">
                    <i class="fas fa-image icon"></i><span>Cambiar fondo</span>
                </button>
                <button id="removeBgButton" type="button" class="btn btn-primary imagepicker-button-action m-l-0" title="Quitar fondo" style="display:none;">
                    <i class="fas fa-eraser icon"></i><span>Quitar fondo</span>
                </button>
            </div>

            <input type="file" id="bgImagePicker" accept="image/*" style="display:none;" />
            -->
        </div>

        <style> @keyframes blinkDot { 0%, 50%, 100% { opacity: 1; } 25%, 75% { opacity: 0; } } </style>
    `;

    // --- Crear overlay de cuenta regresiva ---
    const container = liveArea.querySelector("#videoContainer16_9");
    const overlay = document.createElement("div");
    overlay.id = "countdownOverlay";
    overlay.style.cssText = `
        position:absolute;
        top:0;
        left:0;
        width:100%;
        height:100%;
        display:none;
        align-items:center;
        justify-content:center;
        z-index:20;
        background:rgba(0,0,0,0.4);
        color:white;
        font-size:100px;
        font-weight:400;
        border-radius:5px;
        opacity:0;
        transition: opacity 0.6s ease;
    `;
    container.appendChild(overlay);

    // --- Función global para mostrar cuenta regresiva ---
    window._showCountdownOverlay = (seconds = 3, onFinish) => {
        let count = seconds;
        overlay.textContent = count;
        overlay.style.display = "flex";
        requestAnimationFrame(() => (overlay.style.opacity = "1"));

        const timer = setInterval(() => {
            count--;
            if (count > 0) {
                overlay.textContent = count;
            } else {
                clearInterval(timer);
                overlay.style.opacity = "0";
                setTimeout(() => {
                    overlay.style.display = "none";
                    overlay.textContent = "";
                    if (typeof onFinish === "function") onFinish();
                }, 400);
            }
        }, 1000);
    };

    // --- Referencias ---
    const video = liveArea.querySelector("#previewVideo");
    // const canvas = liveArea.querySelector("#segmentedCanvas");
    // const changeBgButton = liveArea.querySelector("#changeBgButton");
    // const removeBgButton = liveArea.querySelector("#removeBgButton");
    // const bgFileInput = liveArea.querySelector("#bgImagePicker");

    video.srcObject = localStream;

    // --- Cargar librerías MediaPipe ---
    // await loadSelfieSegmentationLibs();

    // if (preservedState.backgroundImage) {
    //     window._recorderState.backgroundImage = preservedState.backgroundImage;

    //     // Esperar a que el video esté listo
    //     await new Promise((resolve) => {
    //         if (video.readyState >= 2) {
    //             resolve();
    //         } else {
    //             video.onloadedmetadata = () => resolve();
    //         }
    //     });

    //     window._currentSegmentationInstance = await initSegmentation(
    //         video, 
    //         canvas, 
    //         preservedState.backgroundImage
    //     );
    //     window._recorderState.isSegmentationActive = true;
    //     removeBgButton.style.display = "inline-flex";
    //     changeBgButton.style.display = "none";
    // }

    // changeBgButton.addEventListener("click", () => bgFileInput.click());

    // bgFileInput.addEventListener("change", async (e) => {
    //     const file = e.target.files[0];
    //     if (!file) return;

    //     const reader = new FileReader();
    //     reader.onload = (ev) => {
    //         const img = new Image();
    //         img.onload = async () => {

    //             window._recorderState.backgroundImage = img;
    //             window._recorderState.isSegmentationActive = true;

    //             // Detener segmentación anterior
    //             if (window._currentSegmentationInstance) {
    //                 await stopSegmentation(window._currentSegmentationInstance);
    //             }

    //             // Crear nueva segmentación
    //             window._currentSegmentationInstance = await initSegmentation(video, canvas, img);

    //             removeBgButton.style.display = "inline-flex";
    //             changeBgButton.style.display = "none";

    //         };
    //         img.src = ev.target.result;
    //     };
    //     reader.readAsDataURL(file);
    //     e.target.value = "";
    // });

    // removeBgButton.addEventListener("click", async () => {

    //     window._recorderState.backgroundImage = null;
    //     window._recorderState.isSegmentationActive = false;

    //     if (window._currentSegmentationInstance) {
    //         await stopSegmentation(window._currentSegmentationInstance);
    //         window._currentSegmentationInstance = null;
    //     }

    //     canvas.style.display = "none";
    //     removeBgButton.style.display = "none";
    //     changeBgButton.style.display = "inline-flex";

    // });

    // --- Indicador de voz ---
    setupVoiceIndicator(localStream, liveArea);

    if (typeof onReady === "function") onReady();
}

function updateVoiceIndicator(stream) {
    // Limpiar contexto anterior si existe
    if (window._voiceAnalyzerContext) {
        try {
            window._voiceAnalyzerContext.close();
        } catch (e) { }
    }
    if (window._voiceAnalyzerInterval) {
        clearInterval(window._voiceAnalyzerInterval);
    }

    const bars = document.querySelectorAll(".bar-audio-ckeditor");
    const micIcon = document.querySelector(".fa-microphone");

    if (!bars.length || !micIcon) {
        console.warn('No se encontraron elementos del indicador de voz');
        return;
    }

    // Verificar que hay audio tracks
    const audioTracks = stream.getAudioTracks();
    if (audioTracks.length === 0) {
        console.warn('No hay audio tracks en el stream');
        return;
    }

    const audioContext = new AudioContext();
    window._voiceAnalyzerContext = audioContext;

    try {
        const source = audioContext.createMediaStreamSource(stream);
        const analyser = audioContext.createAnalyser();
        analyser.fftSize = 64;
        source.connect(analyser);

        const dataArray = new Uint8Array(analyser.frequencyBinCount);
        let smoothLevel = 0;

        window._voiceAnalyzerInterval = setInterval(() => {
            analyser.getByteFrequencyData(dataArray);
            const avg = dataArray.reduce((a, b) => a + b, 0) / dataArray.length;
            const minThreshold = 35;
            const rawLevel = avg < minThreshold ? 0 : (avg - minThreshold) / (128 - minThreshold);
            const level = Math.min(rawLevel, 1);
            smoothLevel = smoothLevel * 0.8 + level * 0.2;

            micIcon.classList.remove("microphone-ckeditor", "mic-low");
            micIcon.classList.add(smoothLevel > 0.6 ? "microphone-ckeditor" : "mic-low");

            const iconColor = getComputedStyle(micIcon).color;

            bars.forEach((bar, i) => {
                const wave = Math.sin(Date.now() / 400 + i * 1.2);
                const height = 3 + (wave + 1) * 5 * smoothLevel + 2;
                bar.style.height = `${height}px`;
                bar.style.background = iconColor;
                bar.style.boxShadow = `0 0 ${smoothLevel * 10}px ${iconColor}`;
            });
        }, 120);

    } catch (error) {
        console.error('Error configurando indicador de voz:', error);
    }
}

// --- Indicador de voz (wrapper inicial) ---
function setupVoiceIndicator(stream, liveArea) {
    updateVoiceIndicator(stream);
}

